// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <span ng-bind=\"grid.appScope.datatable.cellTypesOfService[row.entity.TypeOfService]\"></span>\n</div>\n";
// Exports
module.exports = code;